import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

const im_logo = "https://imagineshared.blob.core.windows.net/portal/retalia_files/logos/sidebar_logo.png";
const dsw_logo = require("../Images/k3-black-padding.png");
const viji_logo = require("../Images/k3_viji_midnight_rgb.png");

export default function Header(props) {
  let logo;
  let loginUrl;
  switch (props.app) {
    case "Imagine":
      logo = im_logo;
      loginUrl = "https://portal.k3imagine.com";
      break;
    case "Dataswitch":
      logo = dsw_logo;
      loginUrl = "https://cloud.k3dataswitch.com";
      break;
    case "Viji":
      logo = viji_logo;
      loginUrl = "https://app.viji.io/login";
      break;
    default:
      logo = im_logo;
  }
  return (
    <Box
      className="app-header-wrap"
      sx={{
        width: "100%",
        position: "fixed",
        top: 0,
        zIndex: 999,
      }}
    >
      <AppBar position="sticky" className="app-header" elevation={0}>
        <Toolbar className="app-toolbar">
          <Box sx={{ flexGrow: 1, textAlign: "left" }}>
            <a href={loginUrl} target="_blank" rel="noreferrer">
              <img src={logo} alt={`${props.app} logo`} className="logo" />
            </a>
          </Box>
          <Box className="login-button-box" sx={{ justifyContent: "flex-end" }}>
            <a href={loginUrl} target="_blank" rel="noreferrer">
              <Button className="login-button" variant="contained" disableElevation>
                Login to App
              </Button>
            </a>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
